import { BaseEntityManager } from "../../components/entityManager";
import { enmControlType, enmPropertyType, IEntityManagerProps, IEntityManagerStates, IInitialData, IMetadata } from "../../components/entityManager/interfaces";
import { IEntity, IFetchingInfo } from "../../components/infrastructure/models";

export enum enmUserTypes {
    Policyholder = 1,
    Spc = 2
}

interface IZobdehUser extends IEntity {

}

export interface IZobdehUserProps extends IEntityManagerProps<IZobdehUser> {
    userType?: enmUserTypes;
    relationSourceId?: number;
}

interface IZobdehUserStates extends IEntityManagerStates<IZobdehUser> {

}

interface IZobdehUserFetchingInfo extends IFetchingInfo {
    UserType?: enmUserTypes;
    RelationSourceId?: number;
}

export class ZobdehUser extends BaseEntityManager<IZobdehUser, IZobdehUserProps, IZobdehUserStates, IZobdehUserFetchingInfo, IInitialData> {
    static initMetadata = (): IMetadata => {
        return {
            name: "ZobdehUser",
            title: "کاربر",
            Properties: [
                {
                    title: "نام کاربری",
                    dataIndex: "UserName",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150
                },
                {
                    title: "نام",
                    dataIndex: "FirstName",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150
                },
                {
                    title: "نام خانوادگی",
                    dataIndex: "LastName",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: false,
                    width: 150
                }
            ]
        };
    }

    onInitializing() {
        this.searchArea = { columnsPerRow: 2 };
        this.searchable = true;

        this.onDataFetching = (fetchingInfo: IZobdehUserFetchingInfo) => {
            fetchingInfo.UserType = this.props.userType;
            fetchingInfo.RelationSourceId = this.props.relationSourceId;
        }
    }
}